import { Constructor } from '../../global/constructor';
import TrackedModel from '~/models/tracked/trackedModel';
import OnFlowError from '~/models/processFlows/onFlowError';
import { RelationType } from '~/models/relationType';

export default function OnProcessFlowErrorable<TBase extends Constructor<TrackedModel>>(Base: TBase) {
  return class extends Base {
    on_flow_error: OnFlowError;

    get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
      return {
        ...super.EMBEDDED_MODELS,
        on_flow_error: {type: OnFlowError, relationType: RelationType.singleObject},
      };
    }

    createEmbeddedObject = {
      ...this.createEmbeddedObject,
      on_flow_error(parent, json): OnFlowError {
        return new OnFlowError(parent).loadFromJson(json);
      },
    };
  };
}